import "../../styles/search.scss";

  const init = () => {
    jQuery(document).ready(function() {
    // Sort JS
    Shopify.queryParams = {};
    if (location.search.length) {
      for (
        var aKeyValue, i = 0, aCouples = location.search.substr(1).split("&");
        i < aCouples.length;
        i++
      ) {
        aKeyValue = aCouples[i].split("=");
        if (aKeyValue.length > 1) {
          Shopify.queryParams[
            decodeURIComponent(aKeyValue[0])
          ] = decodeURIComponent(aKeyValue[1]);
        }
      }
    }
    jQuery("#sort-by")
    .val(
      "{{ collection.sort_by | default: collection.default_sort_by | escape }}"
    )
    .bind("change", function() {
      Shopify.queryParams.sort_by = jQuery(this).val();
      location.search = jQuery.param(Shopify.queryParams).replace(/\+/g, "%20");
    });

      // product card hover functionality
      jQuery("div[data-collection-single-product]").hover(
        function() {
          // hover on
          var par = jQuery(this);
          var url2 = par.find('img[data-product-img].inactive').attr('src')
          if(url2.includes('no-image')) {
            par.find(".atc-btn").removeClass("hidden");
            par.find(".quick-view").removeClass("md:hidden");
            par.find("[data-wishlist-toggle]").removeClass("hidden");
            par.find("[data-variants]").removeClass("hidden");
          } else {
            par.find(".atc-btn").removeClass("hidden");
            par.find(".quick-view").removeClass("md:hidden");
            par.find("[data-wishlist-toggle]").removeClass("hidden");
            par.find("[data-variants]").removeClass("hidden");
            jQuery(this)
              .find("img[data-product-img].active")
              .fadeOut(230, function() {
                jQuery(this).attr("src2", jQuery(this).attr("src"));
                jQuery(this).attr(
                  "src",
                  par.find("img[data-product-img].inactive").attr("src")
                );
                jQuery(this).fadeIn(230, function() {});
              });
          }
        },
        function() {
          // hover off
          var par = jQuery(this);
          var url2 = par.find('img[data-product-img].inactive').attr('src')
          par.find(".atc-btn").toggleClass("hidden");
          par.find(".quick-view").toggleClass("md:hidden");
          par.find("[data-wishlist-toggle]").toggleClass("hidden");
          par.find("[data-variants]").toggleClass("hidden");
          if(!url2.includes('no-image')) {
          jQuery(this)
            .find("img[data-product-img].active")
            .fadeOut(230, function() {
              jQuery(this).attr(
                "src",
                par.find("img[data-product-img].active").attr("src2")
              );
              jQuery(this).fadeIn(230, function() {});
            });
          }
        }
      );
    });
  }

  export default init
